import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_AGREE,
  ACCOUNT_DELETED,
  CURRENTUSER_UPDATE,
  FORGOT_PASSWORD,
  CLEAR_MESSAGE,
} from '../actions';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: true,
  currentUser: null,
  message: '',
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        currentUser: payload,
      };
    case USER_AGREE:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: { ...state.user, Agreement: payload },
      };
    case CURRENTUSER_UPDATE:
      return {
        ...state,
        currentUser: payload,
        loading: false,
      };
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };
    case FORGOT_PASSWORD:
      return {
        ...state,
        message: payload,
      };
    case CLEAR_MESSAGE:
      return { ...state, message: '' };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
    case ACCOUNT_DELETED:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}
